// Issues + Locations live updates (PG server). Single "mutated" subscription per
// entity — fires on create/update/delete; the client upserts the returned row.

import {ISSUE_FIELDS_GQL, LOCATION_FIELDS_GQL} from "./queries";

export const onIssueMutated = /* GraphQL */ `
  subscription onIssueMutated($ownerId: String!, $workspaceId: String!) {
    onIssueMutated(ownerId: $ownerId, workspaceId: $workspaceId) { ${ISSUE_FIELDS_GQL} }
  }
`;

export const onLocationMutated = /* GraphQL */ `
  subscription onLocationMutated($ownerId: String!, $workspaceId: String!) {
    onLocationMutated(ownerId: $ownerId, workspaceId: $workspaceId) { ${LOCATION_FIELDS_GQL} }
  }
`;

// Split subscriptions for IssueDS._subscriptionGQLs
export const onCreateIssue = /* GraphQL */ `
  subscription onCreateIssue($workspaceId: String!) {
    onCreateIssue(workspaceId: $workspaceId) { ${ISSUE_FIELDS_GQL} }
  }
`;
export const onUpdateIssue = /* GraphQL */ `
  subscription onUpdateIssue($workspaceId: String!) {
    onUpdateIssue(workspaceId: $workspaceId) { ${ISSUE_FIELDS_GQL} }
  }
`;
export const onDeleteIssue = /* GraphQL */ `
  subscription onDeleteIssue($workspaceId: String!) {
    onDeleteIssue(workspaceId: $workspaceId) { ${ISSUE_FIELDS_GQL} }
  }
`;

// Split subscriptions for LocationDS._subscriptionGQLs
export const onCreateLocation = /* GraphQL */ `
  subscription onCreateLocation($workspaceId: String!) {
    onCreateLocation(workspaceId: $workspaceId) { ${LOCATION_FIELDS_GQL} }
  }
`;
export const onUpdateLocation = /* GraphQL */ `
  subscription onUpdateLocation($workspaceId: String!) {
    onUpdateLocation(workspaceId: $workspaceId) { ${LOCATION_FIELDS_GQL} }
  }
`;
export const onDeleteLocation = /* GraphQL */ `
  subscription onDeleteLocation($workspaceId: String!) {
    onDeleteLocation(workspaceId: $workspaceId) { ${LOCATION_FIELDS_GQL} }
  }
`;
